import remote from "../remote/bs.ps4";

export default function getRemoteKey(keyCode, ctrlKey, altKey) {
  return remote.keyMap[`${ctrlKey ? "CTRL+" : ""}${altKey ? "ALT+" : ""}${keyCode}`];
}
